import React,{useEffect,useState} from "react";
import ContactSection from "./ContactSection";
import InquirySection from "./InquirySection";
import MapSection from "./MapSection";
import {corefetch, ImageURL } from "../../../Util/axios_core_helper";

const ContactUS_Page = ({ openModal }) => {
   const [BreadcrumList, setBreadcrumList] = useState([]);
  
     const fetchBreadcrumImageData = async () => {
        try {
          const response = await corefetch(
            "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=CONTACT"
          );
          if (response && response.length > 0) {
            console.log("fxftyxfyt:", response);
            setBreadcrumList(response);
          } else {
            setBreadcrumList([]);
            console.log("No Breadcrum found");
          }
        } catch (error) {
          console.error("Error fetching Breadcrum List:", error);
          setBreadcrumList([]);
        }
      };
  
      useEffect(() => {
          fetchBreadcrumImageData();
        }, []);
  
        const backgroundImageStyle = BreadcrumList[0]
        ? {
            backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }
        : {};
  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>Contact Us</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Contact Us</li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </section>
      <ContactSection />
      <InquirySection openModal={openModal} />
      <MapSection />
    </>
  );
};

export default ContactUS_Page;
